import { render, staticRenderFns } from "./TargetPage.vue?vue&type=template&id=50603b35&scoped=true"
import script from "./TargetPage.vue?vue&type=script&lang=js"
export * from "./TargetPage.vue?vue&type=script&lang=js"
import style0 from "./TargetPage.vue?vue&type=style&index=0&id=50603b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50603b35",
  null
  
)

export default component.exports